import { FlexColumn } from "@/components/Flex";
import { spacing } from "@/utils/spacing";
import TeacherAIToolCard from "./TeacherAIToolCard";
import { AI_TOOLS } from "@knowt/syncing/constants/ai-tools";
import { AI_LANDING_TOOLS } from "@knowt/syncing/constants/ai-tools";
import { useMemo } from "react";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import HomeRepeatAutoFillGrid from "@/features/UserContentManagement/HomePage/components/styled/HomeRepeatAutoFillGrid";

const FavoriteAITools = ({ classId }: { classId?: string }) => {
    const { user } = useCurrentUser();

    const allAiTools = [...Object.values(AI_LANDING_TOOLS), ...Object.values(AI_TOOLS)];

    const userFavToolsArray = useMemo(() => {
        return allAiTools.filter(aiTool => user?.favTools?.includes(aiTool.tool));
    }, [user?.favTools]);

    if (!userFavToolsArray?.length) {
        return null;
    }

    return (
        <FlexColumn style={{ gap: spacing.XS_2 }}>
            <span className="bodyBold2">Favorites</span>
            <HomeRepeatAutoFillGrid>
                {userFavToolsArray.map(favTool => (
                    <TeacherAIToolCard key={`${favTool.title}_fav`} tool={favTool} classId={classId} />
                ))}
            </HomeRepeatAutoFillGrid>
        </FlexColumn>
    );
};

export default FavoriteAITools;
